export const HUBSPOT_DEFINED_TYPE = '0';
export const USER_DEFINED_TYPE = '1';
export const INTEGRATOR_DEFINED_TYPE = '2';